module.exports = __webpack_public_path__ + "static/media/ChangeIcon.02dbf887.png";